import {
  Paper,
  Typography,
  WithStyles,
  withStyles,
  Grid,
  Button,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
  Link,
} from "@material-ui/core";
import React, { Component } from "react";
import { MyPATDialog } from "../../common";
import { RequestContentType } from "../types/ContentRequestCreate";
import { topNavStyles } from "../styles/topBarStyle";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import contentRequestServices from "../services/contentRequestServices";
import { generateDefaultContentRequest } from "../helpers/createContentRequest";
import { ContentRequest } from "../types/ContentRequest";
interface Props extends WithStyles<typeof topNavStyles> {
  onClose: () => void;
  classes: any;
  createRequestOpen: boolean;
}

interface State {
  isNewRequest: boolean;
  activeStep: number;
  requestContentType: RequestContentType;
}

class CreateContentRequestPopup extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isNewRequest: true,
      activeStep: 2,
      requestContentType: RequestContentType.QUESTION,
    };
  }
  handleproceed = () => {
    this.setState({
      activeStep: 2,
    });
  };
  handleBack = () => {
    this.setState({
      activeStep: 1,
    });
  };
  handleCardClick = async (type: RequestContentType) => {
    try {
      if (type === RequestContentType.STUDY_MATERIAL) {
        return;
      } else {
        const contentRequest: ContentRequest = await contentRequestServices.saveContentRequest(
          generateDefaultContentRequest(type)
        );

        window.open(`contentRequest/edit/${type}/${contentRequest._id}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  requestTypeCard() {
    const { classes } = this.props;
    return (
      <>
        <Grid container justify="space-between" alignItems="center" className={classes.contentPopup}>
          <Grid item xs={6}>
            <Card
              className={classes.cardRoot}
              elevation={0}
              onClick={() => this.handleCardClick(RequestContentType.QUESTION)}
            >
              <CardContent className={[classes.cardContentRoot, classes.card1].join(' ')}>
                <Grid container justify="flex-start" alignItems="center" style={{flexDirection: 'column'}}>
                  <Grid item>
                    <div className={[classes.cardImageWrapper, classes.purpleBG].join(' ')}>
                      <img
                        alt="item1"
                        src="/assets/svg/contentRequest/question.svg"
                        className={classes.cardImage}
                      />
                    </div>
                  </Grid>
                  <Grid item>
                    <Typography variant="h5" className={classes.contentTitle}>
                      Question(s)
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={6}>
            <Card
              className={classes.cardRoot}
              elevation={0}
              onClick={() => this.handleCardClick(RequestContentType.TEST)}
            >
              <CardContent className={[classes.cardContentRoot, classes.card2].join(' ')}>
                <Grid container justify="flex-start" alignItems="center" style={{flexDirection: 'column'}}>
                  <Grid item>
                    <div className={[classes.cardImageWrapper, classes.greenBG].join(' ')}>
                      <img
                        alt="item1"
                        src="/assets/svg/contentRequest/test.svg"
                        className={classes.cardImage}
                      />
                    </div>
                  </Grid>
                  <Grid item>
                    <Typography variant="h5" className={classes.contentTitle}>
                      Test
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* <Grid item xs={6}>
            <Card className={classes.cardRoot} elevation={0} classes={{root: classes.disableCard}}>
              <CardContent className={[classes.cardContentRoot, classes.card3].join(' ')}>
                <Grid container justify="flex-start" alignItems="center">
                  <Grid item>
                    <div className={[classes.cardImageWrapper, classes.blueBG].join(' ')}>
                      <img
                        alt="item1"
                        src="/assets/svg/contentRequest/study.svg"
                        className={classes.cardImage}
                      />
                    </div>
                  </Grid>
                  <Grid item>
                    <Typography variant="h5" className={classes.contentTitle}>
                      Study Material
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid> */}
        </Grid>
      </>
    );
  }

  render() {
    const { onClose, classes, createRequestOpen } = this.props;
    const { activeStep } = this.state;
    return (
      <MyPATDialog
        dialogOpen={createRequestOpen}
        dialogHasActions={true}
        onDialogClose={onClose}
        dialogHeading={
          activeStep === 1 ? (
            <Typography className={classes.dialogTitle}>
              Request Content
            </Typography>
          ) : (
            <Typography className={classes.dialogTitle}>
              {/* <Link color="inherit" onClick={this.handleBack} className={classes.backArrow}>
                <span>
                  <ArrowBackIcon />
                  &nbsp;
                </span>
              </Link> */}
              Request Content | Create New
            </Typography>
          )
        }
        isAlignCenter={false}
        variantHeader="leftHeader"
        customButtonVariant="withoutBorderCloseIcon"
        isCustomBackground={false}
        isborderDialogAction={true}
        otherDialogProps={{
          fullWidth: false,
        }}
        customDialogActions={
          activeStep === 1 && (
            <Grid container justify="flex-end">
              <Button color="primary" onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleproceed}
              >
                Proceed
              </Button>
            </Grid>
          )
        }
      >
        {activeStep === 2 ? (
          this.requestTypeCard()
        ) : (
          <Grid container justify="flex-start">
            <Grid item xs={12}>
              <Typography className={classes.HeadingText}>
                Choose type of content request:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                classes={{ root: classes.labelText }}
                control={<Radio name="studyMaterial" color="primary" checked />}
                label="Create New Content (Test/Questions/Study Material)"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                classes={{ root: classes.labelText, disabled: classes.disableText }}
                control={<Radio name="studyMaterial" color="primary" classes={{disabled: classes.disableText}}/>}
                label="Update Existing Content"
                disabled
              />
            </Grid>
          </Grid>
        )}
      </MyPATDialog>
    );
  }
}

// @ts-ignore
export default withStyles(topNavStyles)(CreateContentRequestPopup);
